import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="currentColor" d="M2 3h16v1H2zM2 9.5h16v1H2zM2 16h16v1H2z" /></svg>;